module.exports = __webpack_public_path__ + "225cc645283753da63080d02086c4858.png";